import { Link, useNavigate } from 'react-router-dom';
import { setMode } from '../utils/mode';

function WelcomePage() {
  const navigate = useNavigate();

  // NOTE: handleTurboClick removed - Turbo Mode disabled

  const handleStoryClick = () => {
    setMode('normal');
    navigate('/hub');
  };

  return (
    <div className="welcome-page">
      <div className="welcome-container">
        <div className="welcome-header">
          <h1 className="welcome-title">Atlas · System Recommendation</h1>
          <p className="welcome-subtitle">
            Launch the standalone web app to get started
          </p>
        </div>

        <div className="welcome-options">
          {/* NOTE: Turbo Mode REMOVED - incomplete feature path that bypasses proper data collection */}

          <Link to="/hub" onClick={handleStoryClick} className="welcome-option welcome-option-primary">
            <div className="option-icon">🚀</div>
            <h2 className="option-title">Standalone Web App</h2>
            <p className="option-description">
              Modern React-based application with multiple interactive interfaces.
              Choose from story-driven guidance, classic tabbed navigation, or 
              professional export/print views.
            </p>
            <div className="option-features">
              <span className="feature-tag">✓ Story UI</span>
              <span className="feature-tag">✓ Classic tabs</span>
              <span className="feature-tag">✓ Export/Print</span>
            </div>
            <div className="option-subtext">
              Includes: Web App View • Classic • Export/Print
            </div>
            <div className="option-button">Start Web App →</div>
          </Link>

        </div>

        <div className="welcome-footer">
          <p className="footer-text">
            All interfaces provide comprehensive heating system
            recommendations tailored to UK properties.
          </p>
          <Link to="/about" className="about-link">
            About & Disclaimer
          </Link>
        </div>
      </div>
    </div>
  );
}

export default WelcomePage;
